"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var encode_email_1 = __importDefault(require("./helpers/encode-email"));

var find_closest_domain_1 = __importDefault(require("./helpers/find-closest-domain"));

var parse_email_1 = __importDefault(require("./helpers/parse-email"));

function suggestEmail(opts) {
  var encodedEmail = encode_email_1.default(opts.email.toLowerCase());
  var email = parse_email_1.default(encodedEmail);

  if (!email) {
    return undefined;
  }

  var domains = opts.domains,
      domainThreshold = opts.domainThreshold,
      distanceFunction = opts.distanceFunction,
      secondLevelDomains = opts.secondLevelDomains,
      topLevelDomains = opts.topLevelDomains;

  if (secondLevelDomains && topLevelDomains) {
    // If the email is a valid 2nd-level + top-level, do not suggest anything.
    // if (hasValidSecondLevelDomain(email) && hasValidTopLevelDomain(email)) {
    if (secondLevelDomains.indexOf(email.secondLevelDomain) !== -1 && topLevelDomains.indexOf(email.topLevelDomain) !== -1) {
      return undefined;
    }
  }

  var closestDomain = find_closest_domain_1.default({
    domain: email.domain,
    domains: domains,
    distanceFunction: distanceFunction,
    threshold: domainThreshold
  });

  if (closestDomain) {
    if (closestDomain == email.domain) {
      // The email address exactly matches one of the supplied domains; do not return a suggestion.
      return undefined;
    } else {
      // The email address closely matches one of the supplied domains; return a suggestion
      return {
        address: email.address,
        domain: closestDomain,
        full: email.address + '@' + closestDomain
      };
    }
  } // The email address does not closely match one of the supplied domains


  var closestSecondLevelDomain = find_closest_domain_1.default({
    domain: email.secondLevelDomain,
    domains: secondLevelDomains,
    distanceFunction: distanceFunction,
    threshold: opts.secondLevelThreshold
  });
  var closestTopLevelDomain = find_closest_domain_1.default({
    domain: email.topLevelDomain,
    domains: topLevelDomains,
    distanceFunction: distanceFunction,
    threshold: opts.topLevelThreshold
  });

  if (email.domain) {
    closestDomain = email.domain;
    var rtrn = false;

    if (closestSecondLevelDomain && closestSecondLevelDomain != email.secondLevelDomain) {
      // The email address may have a mispelled second-level domain; return a suggestion
      closestDomain = closestDomain.replace(email.secondLevelDomain, closestSecondLevelDomain);
      rtrn = true;
    }

    if (closestTopLevelDomain && closestTopLevelDomain != email.topLevelDomain && email.secondLevelDomain !== '') {
      // The email address may have a mispelled top-level domain; return a suggestion
      closestDomain = closestDomain.replace(new RegExp(email.topLevelDomain + '$'), closestTopLevelDomain);
      rtrn = true;
    }

    if (rtrn) {
      return {
        address: email.address,
        domain: closestDomain,
        full: email.address + '@' + closestDomain
      };
    }
  }
  /* The email address exactly matches one of the supplied domains, does not closely
   * match any domain and does not appear to simply have a mispelled top-level domain,
   * or is an invalid email address; do not return a suggestion.
   */


  return undefined;
}

exports.default = suggestEmail;